<template>
  <div :class="classModifiers">
    <template v-if="isYoutube">
      <youtube
        class="video-view__youtube"
        ref="youtubePlayer"
        :player-width="playerWidth"
        :player-height="playerHeight"
        :video-id="youtubeVideoId"
        :mute="mute"
        :player-vars="youtubePlayerVars"
        @ended="youtubeEnded"
        @playing="onPlaying"
        @paused="onPaused"
      >
      </youtube>
    </template>
    <template v-else-if="isVimeo">
      <vimeo-player
        class="video-view__vimeo"
        :video-id="vimeoVideoId"
        :autoplay="autoPlay"
        :loop="loop"
        :options="vimeoPlayerVars"
        :player-width="playerWidth"
        :player-height="playerHeight"
        @playing="onPlaying"
        @paused="onPaused"
      >
      </vimeo-player>
    </template>
  </div>
</template>

<script src="./video-view.js"></script>
<style src="./video-view.scss" lang="scss"></style>
